import React, { Component } from 'react';

import { connect } from 'react-redux';

import XLSX from 'xlsx';
import GoogleMapReact from 'google-map-react';
import proj4 from 'proj4';
import Supercluster from 'supercluster';
import L from 'leaflet';
import { Map, TileLayer } from 'react-leaflet';
import Marker from 'react-leaflet-enhanced-marker';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import { SyncLoader } from 'react-spinners';

import { api, apiConst } from '../backend/api.js'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import BVMarker from '../img/BVMarker.png';

import { DATABASE } from '../backend/model';
import { generatePDF } from '../PDFModel.jsx';
import { MIMain, MISide, MapMarker, Mask, Cluster } from '../dumb_component';

const createClusterCustomIcon = function (cluster) {
  return L.divIcon({
    html: `<div class='cluster-style'>${cluster.getChildCount()}</div>`,
    className: 'cluster-container',
    iconSize: L.point(40, 40, true),
  });
}

class MainInterface extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mapHasLoaded: false,
      islandOverview: false,
      focusedIsland: false,
      markerList: [],
      askForSaveMask: false,
      loadingIsland: false,
      imgHasChanged: false
    };
  };

  componentDidMount() {
    /*let mainPanel = document.getElementById('result-main');
    let maskPanel = document.getElementById('main-mask');
    maskPanel.style.pointerEvents = 'auto';
    mainPanel.style.display = 'flex';*/

    
/*
    var map = L.map('map').setView(, 8.2);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    }).addTo(map);
    this.markerLoader();*/
    let markerList = this.markerLoader();
    console.log('prop', this.props)
    console.log('MARKERLIST', markerList)
    this.setState({
      markerList
    })
  }

  createPDF = () => {
    const { focusedIsland } = this.state;

    console.log('Island to pdf:', focusedIsland)

    let fakeIsland = {};

    Object.keys(DATABASE).forEach(sheet => {
      fakeIsland[sheet] = {};
      Object.keys(DATABASE[sheet]).forEach(field => {
        fakeIsland[sheet][field] = `[${sheet}] - ${field}`
      })
    })

    pdfMake.createPdf(generatePDF(focusedIsland)).download();
  }

  saveIsland = (quit) => {
    document.getElementById('mi-main-content').className = '';
    document.getElementById('unsaved-alert').style.display = 'none'
    const { focusedIsland } = this.state;

    let n = {  };
    let d = document.getElementsByClassName('wpc-text')
    let modifiedFields = [];
    for(let i = 0; i < d.length; i++) {
      if(d[i].lastChild.firstChild.style.color == 'red') {
        modifiedFields.push([d[i].id, d[i].lastChild.firstChild.value]);
      }
    }

    let imgHasChanged = false;
    let imgContainers = document.getElementsByClassName('wpc-img img-contained');
    if(!focusedIsland.IMAGES && !!imgContainers.length) {
      imgHasChanged = true;
    }
    
    else if(!!focusedIsland.IMAGES && imgContainers.length != Object.keys(focusedIsland.IMAGES).length) {
      imgHasChanged = true;
    }
    else {
      for(let i = 0; i < imgContainers.length; i++) {
        console.log("img : ", imgContainers[i])
        
        if(imgContainers[i].src != null)
          imgHasChanged = true;
      }
    }
    
    if(!!modifiedFields.length || imgHasChanged) {
      console.log('modifiedFields', modifiedFields)
      modifiedFields.forEach(change => {
        let [dest, tx] = [...change];
        let [table, field] = dest.split(':::');
        if(table.includes('::')) {
          let [t, vern] = table.split('::');
          let isDecennal = false
          console.log('t', t, vern, field)
          if(t.includes(':')){
            let [ditch, tmp] = t.split(':');
            t = tmp;
            isDecennal = true;
          }
          if(field.includes('STATUT')) {
            if(n[t] == undefined)
              n[t] = {vern: {[field]: tx}}
            else if(n[t][vern] == undefined)
              n[t][vern] = {[field]: tx}
            else
              n[t][vern][field] = tx;
          } else {
            let targetKey = t == 'OISEAUX_MARINS_NICHEURS'
                ? isDecennal
                  ? 'R_D_MOY'
                  : 'RESULT_SUIVIS'
                : t == 'AUTRES_SP_AVIF'
                  ? 'RESULT'
                  : t == 'WETLAND'
                    ? 'EFF_WETLAND'
                    : undefined
            console.log('tt', n, t, vern, field)
            if(n[t] == undefined)
              n[t] = {vern: {field:{ [targetKey]: tx}}};
            if(n[t][vern] == undefined)
              n[t][vern] = {field:{ [targetKey]: tx}};
            if(n[t][vern][field] == undefined)
              n[t][vern][field] = { [targetKey]: tx};
            if(n[t][vern][field][targetKey] == undefined)
              n[t][vern][field][targetKey] = 0;
            n[t][vern][field][targetKey] = tx
          }
        }
        else {
          if(n[table] == undefined)
            n[table] = {};
          n[table][field] = tx;
        }
      });
  
      const cleanObj = (obj, newObj = {}) => {
        if(typeof(obj) === 'object') {
          if(Array.isArray(obj)) {
            obj.forEach(o => {
              console.log('array O:', o)
              newObj[o] = cleanObj(o, newObj);
            })
          }
          else { 
            Object.keys(obj).forEach(o => {
              if(typeof(obj[o]) === 'object'){
                newObj[o] = cleanObj(obj[o], newObj[o]);
              }else if(obj[o].length > 0 || typeof(obj[o]) == 'number') {
                newObj[o] = obj[o];
              }
              else {
                console.log('ELSED :', o, obj[o], typeof obj[o], obj[o].length);
                obj[o] = '--DELETE';
              }
            });
          }
        }
        Object.keys(obj).forEach(k => {
          if(typeof obj[k] == 'string' && obj[k].length === 0)
            delete obj[k];
          if(typeof obj[k] == 'object' && Object.keys(obj[k]).length === 0)
            delete obj[k];
        });
        return obj
      }
  
      let m = cleanObj(n);
  
      let imgContainers = document.getElementsByClassName('wpc-img img-contained');
      m.IMAGES = {};
      for(let i = 0; i < imgContainers.length; i++) {
        console.log(imgContainers[i]);
        console.log(imgContainers[i].id);
        console.log('name: ', imgContainers[i].name);
        if(imgContainers[i].src != null)
          m.IMAGES[imgContainers[i].id] = imgContainers[i].src;
      }
  
      let srObj = {}
  
      api(apiConst.SAVE, {key: focusedIsland.ID.HISTOLITT_V2, data: m}, (r) => {
        console.log('R :', r)
        if(!!r) {
          Object.keys(r.searchReady).map(k => {
            srObj[k] = r.searchReady[k];
          })
          this.props.registerChangeInSearchReadyDatabase(srObj, r.sneakPeak);

          r.island.ID = focusedIsland.ID;
          this.setState({
            focusedIsland: r.island,
            islandOverview: false
          });
        }
        console.log('no response from api');
      });
  
      //this.props.registerChangeInDatabase(focusedIsland.ID.HISTOLITT_V2, m);
      if(quit)
        this.quitIslandData();
    }
    else {
      console.log('nothing was changed');
    }
    
  }

  createExcel = database => {
    let wb = XLSX.utils.book_new();
    let db = database;

    console.log(db);
    
    Object.keys(db).forEach(sheet => {
      let merges = {};
      if(db[sheet].hasMerges) {
        Object.keys(db[sheet].hasMerges).forEach(mergeName => {
          console.log('mergeName', mergeName, db[sheet].hasMerges[mergeName])
          merges[mergeName] = {s: undefined, e: undefined};
          db[sheet].hasMerges[mergeName].forEach(field => {
            console.log('e',field)
            if(merges[mergeName].s == undefined)
              merges[mergeName].s = { c: db[sheet].columnNames.indexOf(field), r: 0 };
            merges[mergeName].e = { c: db[sheet].columnNames.indexOf(field), r: 0 };
          });
        });
        console.log('merges', merges)
      };
      db[sheet].content.unshift(db[sheet].columnNames);
      console.log('content', db[sheet].content);

      let sheetMergesProps = [];
      let mergeLine = [];
      
      Object.keys(merges).forEach(columnName => {
        for(let i = mergeLine.length; i < merges[columnName].s.c; i++)
          mergeLine.push(undefined);
        mergeLine.push(columnName);

        sheetMergesProps.push(merges[columnName]);
      });
      if(mergeLine.length > 0)
        db[sheet].content.unshift(mergeLine);
      
      let ws = XLSX.utils.aoa_to_sheet(db[sheet].content);
      if(sheetMergesProps.length > 0)
        ws['!merges'] = sheetMergesProps;
      console.log(ws);
      XLSX.utils.book_append_sheet(wb, ws, sheet);
    });
    XLSX.writeFile(wb, 'out.xlsx');
  };

  markerLoader = (sneakPeak) => {

    const { searchAnswers } = this.props;

    let source = !!searchAnswers ? searchAnswers : this.props.sneakPeak;

    console.log('Source Length :', Object.keys(source).length);
    console.log("source", source);

    if(!!sneakPeak) {
      let markerList = Object.keys(source).map((key, index) => {
        if(!!sneakPeak[key] && sneakPeak[key].COORD_X && sneakPeak[key].COORD_Y) {
          try {
            let [lat, long] = [parseFloat(sneakPeak[key].COORD_X), parseFloat(sneakPeak[key].COORD_Y)];
            let isLambert93 = ((lat >= 90 || lat <= -90) && (long >= 180 || long <= -180))

            if(typeof(lat) != 'number') {
              console.log('not a number')
            } else {
              if(isLambert93)
                [long, lat] = proj4('EPSG:2154', 'WGS84', [lat, long]);
              
              return(
                <Marker
                  className='search-result'
                  id={key}
                  key={key}
                  position={[lat, long]}
                  onMouseOut={(e) => {
                    this.setState({islandOverview: false})
                  }}
                  onMouseOver={(props) => {
                    if(!this.state.islandOverview){
                      this.setState({islandOverview: sneakPeak[props.id]})
                    }
                  }}
                  onClick={(props) => {
                    this.readIslandData(props.id)
                  }} />
              ) 
            }
          } catch(e) {
            console.log('ERROR:', key, sneakPeak[key], index, e)
          }
        }
      }).filter((v, i, s) => v != undefined);
      return markerList;
    }
    else {
      return undefined
    }
  };

  sideResults = (sneakPeak) => {
    const { islandCollection, searchAnswers } = this.props;

    if(searchAnswers != null){
      let sideResultList = Object.keys(searchAnswers).map((key, index)=> {

        if(!!sneakPeak[key])
          return {
              HISTOLITT_V2: key,
              NOM_SHOM: !!sneakPeak[key].NOM_SHOM ? sneakPeak[key].NOM_SHOM : 'Non renseigné',
              IGN: !!sneakPeak[key].IGN ? sneakPeak[key].IGN : 'Non renseigné'
          }
        else return {};
      });
      return !!sideResultList ? sideResultList : [];
    }
    return [];
  };

  onHoverInHandler = id => {
    console.log(id)
    this.setState({islandOverview: id})
  };

  onHoverOutHandler = () => {
    this.setState({islandOverview: false})
  };

  readIslandData = id => {
    api(apiConst.GET, {key: id}, (r) => {
      let maskPanel = document.getElementById('main-mask');
      maskPanel.style.pointerEvents = 'auto';
      if(!r.island.ID){
        r.island.ID = { HISTOLITT_V2: id };
      }
      this.setState({
        focusedIsland: r.island,
        islandOverview: false
      });
    });
  };

  changeIslandData = (table, field, text) => {
    console.log('changed data:',table, field, text)
  }

  checkForUnsavedChanges = () => {
    let d = document.getElementsByClassName('wpc-text')
    let dataChanged = false;
    for(let i = 0; i < d.length; i++) {
      if(d[i].lastChild.firstChild.style.color == 'red') {
        dataChanged = true
        break
      }
    }
    console.log(dataChanged);
    if(!dataChanged) {
      this.quitIslandData();
    } else {
      document.getElementById('mi-main-content').className = 'blurred'
      document.getElementById('unsaved-alert').style.display = 'flex'
    }
  }

  quitIslandData = () => {
    document.getElementById('mi-main-content').className = '';
    document.getElementById('unsaved-alert').style.display = 'none'
    let mainPanel = document.getElementById('result-main');
    let maskPanel = document.getElementById('main-mask');
    maskPanel.style.pointerEvents = 'none';
    mainPanel.style.display = 'none';
    this.setState({focusedIsland: false});
  };

  mapOption = (maps) => {
    return { fullscreenControl: false }
  };

  render() {
    const { islandCollection, isAdmin, sneakPeak } = this.props;
    const { islandOverview, focusedIsland, sidePreResults, askForSaveMask, loadingIsland } = this.state;

    console.log('REDUX TEST', this.state.focusedIsland, sneakPeak)

    //let sneakPeak = JSON.parse(window.localStorage.getItem('sneakPeak'));

    /**
     * urndbm22l4ylbs7pmzgexzey
     * open street map :
     *      url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
            attribution='&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors' />


        Geoportal map :
                    url='https://wxs.ign.fr/{apikey:"choisirgeoportail"}/geoportail/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE={"normal"}&TILEMATRIXSET=PM&FORMAT={"image/jpeg"}&LAYER=ORTHOIMAGERY.ORTHOPHOTOS&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}'
            attribution='&copy; <a target="_blank" href="https://www.geoportail.gouv.fr/">Geoportail France</a> contributors' />
     */
    return(
      <div id='main-interface'>
        <Map center={[48.1, -2.932644]} zoom={8.2} zoomControl={false} maxZoom={20} minZoom={7} >
          <TileLayer
            url='https://wxs.ign.fr/{apikey}/geoportail/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE={style}&TILEMATRIXSET=PM&FORMAT={format}&LAYER=ORTHOIMAGERY.ORTHOPHOTOS&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}'
            style={"normal"}
            apikey={'choisirgeoportail'}
	          format={'image/jpeg'}
            attribution='&copy; <a target="_blank" href="https://www.geoportail.gouv.fr/">Geoportail France</a>' />
            <MarkerClusterGroup
              showCoverageOnHover={false}
              spiderfyOnMaxZoom={false}
              removeOutsideVisibleBounds={true}
              maxClusterRadius={30}
              iconCreateFunction={createClusterCustomIcon} >
              {this.markerLoader(sneakPeak)}
            </MarkerClusterGroup>
        </Map>
        { this.props.children }
        
        <div id='main-interface-mask' style={{ pointerEvents: 'none'}}>
          <div id='main-mask' style={{ flex: 4, pointerEvents: 'none'}}>
            {
              focusedIsland ?
                <MIMain 
                  focusedIsland={focusedIsland}
                  check={() => this.checkForUnsavedChanges()}
                  quit={() => this.quitIslandData()}
                  save={(quitBool) => this.saveIsland(quitBool)}
                  changeData={(table, field, text) => this.changeIslandData(table, field, text)}
                  imgHasChanged={() => this.setState({imgHasChanged: true})}/>
              :
                null
            }
          </div>
          <MISide
            overview={islandOverview}
            results={this.sideResults(sneakPeak)}
            readIslandData={(id) => this.readIslandData(id)}
            createPdf={() => this.createPDF()}
            saveIsland={() => this.saveIsland()}
            pi={!!focusedIsland}
            isAdmin={isAdmin}/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { isAdmin } = state.userReducer;
  const { focusedIsland } = state.sharedStateReducer;
  return { isAdmin, focusedIsland }
}

export default connect(mapStateToProps, {})(MainInterface);